import { Layout } from 'components/layout';

import { CustomMetadata } from 'components/metadata';
import { allMetadata } from 'constants/metadata';

import { IBlogPost } from 'constants/types';

import { Icon } from 'common/icon';
import { Breadcrumbs } from 'components/bredcrambs';
import { Title } from 'components/title';
import { Routes } from 'constants/routes';
import { blogAndNewsPage } from 'constants/routes-breadcrumbs';
import { INavItem } from 'constants/types';
import { NavigationBar } from '../casino/casino-navigations';
import { NewsBlock } from './block';
import { NewsArticleContainer } from './last-topics';
import styles from './styles.module.css';

export type Props = {
  category?: string;
  posts: IBlogPost[];
  topPosts: IBlogPost[];
};

const navItems: INavItem[] = [
  {
    icon: <Icon.Options />,
    text: 'Blogs',
    anchor: `${Routes.blogAndNews}/blogs`,
  },

  {
    icon: <Icon.Search width="16" height="16" />,
    text: 'RTP Checks',
    anchor: `${Routes.blogAndNews}/rtpchecks`,
  },

  {
    icon: <Icon.StarTransparent />,
    text: 'Bigwins',
    anchor: `${Routes.blogAndNews}/bigwins`,
  },

  {
    icon: <Icon.News />,
    text: 'News',
    anchor: `${Routes.blogAndNews}/news`,
  },
];

export const BlogAndNewsPage = ({
  posts,
  topPosts,
  category = 'BlogAndNews',
}: Props) => {
  let metadata = allMetadata.blogAndNews;
  let blogAndNewsCategory = 'BlogAndNews';
  let title = 'Essential BlogAndNews About Online Casinos';
  let description = `Dive into the world of online casinos with our comprehensive guides and in-depth articles. Whether you're looking to understand the basics, improve your gaming strategies, or find the best online casinos, we’ve gathered the best content to give you a complete and safe gambling experience. Stay informed with expert advice and up-to-date information for every level of player. Let us be your trusted source for everything related to online gaming.`;

  switch (category) {
    case 'rtpchecks':
      title = 'We Check RTP at Famous Casino Brands and Expose Scammers';
      description =
        'We ensure that your gaming experience is fair by verifying RTP rates at well-known online casinos. Our goal is to help players avoid scams and find casinos that offer real chances of winning.';
      blogAndNewsCategory = 'RTP Checks';
      break;
    case 'bigwins':
      title = 'Record Big Wins at the Casino';
      description =
        'Discover the stories behind record-breaking wins in online casinos. Learn about the lucky players and streamers who have hit it big and how their success can inspire your own gaming journey.';
      blogAndNewsCategory = 'Bigwins';
      break;
    case 'news':
      metadata = allMetadata.blogAndNewsNews;
      title = 'Gambling News';
      description =
        'Stay up-to-date with the latest happenings in the world of online casinos and gambling. Our news section covers industry trends, new game releases, and crucial updates that every player should know.';
      blogAndNewsCategory = 'News';
      break;
    case 'blogs':
      metadata = allMetadata.blogAndNewsBlogs;
      title = `Gambling Blogs`;
      description = `Gambling blogs are where players share their stories, tips, and knowledge. These blogs offer a personal, relatable approach to learning about casinos, games, and strategies. Whether you're looking to improve your chances or simply stay entertained, gambling blogs are a great way to engage with the gaming community.`;
      blogAndNewsCategory = 'Blogs';
      break;
    default:
      blogAndNewsCategory = 'BlogAndNews';
  }

  return (
    <div>
      <CustomMetadata metadata={metadata} />
      <Layout hasFooter isSearchInputMobileVisible bgVariant="basic">
        <main className={styles.main}>
          <div className={styles.container_s}>
            <div className={styles.breadcrumbs}>
              <Breadcrumbs
                items={[
                  ...blogAndNewsPage,
                  ...(category !== 'BlogAndNews'
                    ? [
                        {
                          id: 1,
                          path: `/${Routes.blogAndNews}/${category}`,
                          title: blogAndNewsCategory,
                        },
                      ]
                    : []),
                ]}
              />
            </div>
            <Title
              text={title}
              description={description}
              navigationBar={
                <div className={styles.navigation}>
                  <NavigationBar
                    items={navItems}
                    navItemClassName={styles.navItem}
                    variantBg="notransparent"
                    variantPadding="big"
                  />
                </div>
              }
            />
            {topPosts?.length > 0 && (
              <NewsBlock posts={topPosts} type="blog-and-news" />
            )}
            <NewsArticleContainer
              blogs={posts}
              category={blogAndNewsCategory}
            />
          </div>
        </main>
      </Layout>
    </div>
  );
};
